<template>
  <div>
    <section class="addtocart_count ratio_square">
      <div class="container">
        <div class="row">
          <div class="col nopadding">
            <div class="title4">
              <h2 class="title-inner4">{{products.grouptitle}}</h2>
<!--              <h4>{{products.groupsubtitle}}</h4>-->
              <router-link v-if="products.products.length" class="viewAll" :to="'shop/viewAll/' + listIndex">View All:</router-link>
            </div>            
            <div v-swiper:mySwiper="swiperOption">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide swiper-slider-width"
                  v-for="(product,index) in products.products"
                  :key="index"
                >
                  <div class="product-box">
                    <productBox
                      @opencartmodel="showCartModal"
                      :product="product"
                      :index="index"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import productBox from '@/components/product-box/home-product-box'
export default {
  props: ['products', 'listIndex'],
  components: {
    productBox
  },
  data() {
    return {
      title: 'top collection',
      showCart: false,
      showquickviewmodel: false,
      showcomapreModal: false,
      quickviewproduct: {},
      comapreproduct: {},
      dismissSecs: 5,
      dismissCountDown: 0,
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  },
  methods: {
    alert(item) {
      this.dismissCountDown = item
    },
    showCartModal(item) {
      this.showCart = item
      this.$emit('openCart', this.showCart)
    },
    showquickview(item, productData) {
      this.showquickviewmodel = item
      this.quickviewproduct = productData
      this.$emit('openQuickview', this.showquickviewmodel, this.quickviewproduct)
    },
    showcomparemodal(item, productData) {
      this.showcomapreModal = item
      this.comapreproduct = productData
      this.$emit('openCompare', this.showcomapreModal, this.comapreproduct)
    }
  }
}
</script>
<style scoped>
  @font-face {
    font-family: "Neue75";
    src: local("Neue75"),
    url('../../../assets/fonts/Neue-Haas-Grotesk-Display-Pro-75-Bold.ttf') format("truetype");
  }
  .viewAll {
    color: #2774ae;
    cursor: pointer;
    font-size: 20px;
  }
  .title-inner4{
    font-family: "Neue75";
  }
</style>